const rightText = document.querySelectorAll(".rightDiv");
const leftText = document.querySelectorAll(".leftDiv");
const topText = document.querySelectorAll(".topDiv");
const bottomText = document.querySelectorAll(".bottomDiv");
const leftTrippleText = document.querySelectorAll(".leftTrippleDiv")
const middleTrippleText = document.querySelectorAll(".middleTrippleDiv")
const rightTrippleText = document.querySelectorAll(".rightTrippleDiv")

const observer2 = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);  
        }
    })
}, {threshold:0.1});

rightText.forEach(rightDiv => observer2.observe(rightDiv))
leftText.forEach(leftDiv => observer2.observe(leftDiv))
topText.forEach(topDiv => observer2.observe(topDiv))
bottomText.forEach(bottomDiv => observer2.observe(bottomDiv))
leftTrippleText.forEach(leftTrippleDiv => observer2.observe(leftTrippleDiv))
middleTrippleText.forEach(middleTrippleDiv => observer2.observe(middleTrippleDiv))
rightTrippleText.forEach(rightTrippleDiv => observer2.observe(rightTrippleDiv))